<template>
  <a-modal title="抽检确认单" v-model="visible" width="960px" :footer="null" centered @cancel="close">
    <div class="detail-container" ref="myContainer">
      <a-radio-group v-model="panelType" class="panel-group">
        <a-radio-button value="1">抽检确认单</a-radio-button>
      </a-radio-group>
      <a-divider />
      <div class="button-group">
        <a-button type="primary" @click="print">打印</a-button>
      </div>
      <invoice-print ref="print" :printObj="printObj" v-show="panelType==1" />
    </div>
  </a-modal>
</template>
<script>
import { Modal, Divider } from "ant-design-vue";
import InvoicePrint from "./InvoicePrint";
export default {
  components: {
    AModal: Modal,
    ADivider: Divider,
    InvoicePrint
  },
  data() {
    return {
      panelType: "1",
      visible: false,
      printObj: []
    };
  },
  methods: {
    print() {
      this.$refs.print.print();
    },
    open(printObj) {
      this.printObj = printObj;
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./templateDetail.scss";
</style>